import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useBranding } from "@/lib/branding";
import { motion } from "framer-motion";
import { Scales } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const { branding } = useBranding();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/guest/forgot-password`, { email });
      setDone(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-sm bg-slate-900 flex items-center justify-center">
            <Scales size={22} weight="bold" className="text-white" />
          </div>
          <div className="font-display text-xl text-slate-900">{branding.firm_name}</div>
        </div>

        <div className="label-tracking">Guest access</div>
        <h2 className="font-display text-3xl sm:text-4xl text-slate-900 mt-2 leading-tight">Reset your password.</h2>

        {done ? (
          <p data-testid="forgot-sent" className="mt-6 text-sm text-slate-600">
            If an account exists for that email, we've sent a reset link. Check your inbox (and spam folder).
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6" data-testid="forgot-form">
            <label className="block text-xs font-medium text-slate-600 mb-1">Email address</label>
            <input
              data-testid="forgot-email"
              type="email" autoComplete="email" value={email}
              onChange={(e) => setEmail(e.target.value)} required
              className="w-full mb-6 px-3 py-2.5 border border-slate-300 rounded-sm text-sm focus:outline-none focus:border-slate-900"
            />
            <button
              data-testid="forgot-submit"
              type="submit" disabled={submitting}
              className="w-full px-4 py-3 rounded-sm bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 disabled:opacity-60"
            >
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <p className="mt-6 text-sm text-slate-500">
          <Link to="/login" className="text-blue-600 hover:underline">Back to sign in</Link>
        </p>
      </motion.div>
    </div>
  );
}
